<template>
    <div class="main-body">
        <div class="header">
            预工单
        </div>
        <div class="out">

            <div class="search2">
              <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>
              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">
              <el-table-column prop="elderlyDTO.name" label="姓名" width="150"></el-table-column>
              <el-table-column prop="elderlyDTO.zoneName" label="所属区域" width="100"></el-table-column>

              <el-table-column label="图片" width="60">
                <template slot-scope="scope">
                  <template v-for="item in scope.row.listOrderGoodsDTO">
                    <div :key="item.goodsName" >
                      <el-popover placement="right" title="" trigger="click" v-if="imgUrl+item.goodsImg">
                        <img :src="imgUrl+item.goodsImg"  style="width: 500px"/>
                        <img slot="reference" :src="imgUrl+item.goodsImg" style="width:100%">
                      </el-popover>
                    </div>
                  </template>
                </template>
              </el-table-column>

              <el-table-column label="单价" width="60">
                <template slot-scope="scope">
                  <template v-for="item in scope.row.listOrderGoodsDTO">
                    <div :key="item.number" style="padding-bottom: 5px;">
                      {{item.goodsPrice}}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="60">
                <template slot-scope="scope">
                  <template v-for="item in scope.row.listOrderGoodsDTO">
                    <div :key="item.number" style="padding-bottom: 5px;">
                      {{item.number}}
                    </div>
                  </template>
                </template>
              </el-table-column>

              <el-table-column prop="price" label="总价" width="80"></el-table-column>

              <el-table-column prop="createTime" :formatter="timefilter" width="200"
                               label="创建时间"></el-table-column>

              <el-table-column prop="planTime" :formatter="timefilter" width="200"
                               label="预约时间"></el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>


        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                zoneValue:[],
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                imgUrl:this.$imgUrl,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        components:{
            Add
        },
        created(){
            this.getList();
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })

            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            //日期格式
            timefilter2(row){
                //return timefilters(row.listOrderGoodsDTO[0].planTime)
              return timefilters(row)
            },
          timefilter(row, column, cellValue) {
            return timefilters(cellValue);
          },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/PageForStaffBusinessSchedule",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfo.list;
                        this.totalItems = response.data.data.pageInfo.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

